import React from "react";
import RadioCirclePng from 'gui/components/formikRadioInput/components/radio/components/radioCirclePng';

export interface IRadioProps {
  state?: boolean;
  onClick?: (state: boolean) => void;
  labelTrue?: string;
  labelFalse?: string;
}

const NotOkRadioCircle = (props: IRadioProps) => {
  return <RadioCirclePng
    {...props}
    radioSelectedPath={"/img/notOkSelected.png"}
    radioNotSelectedPath={"/img/notOkNotSelected.png"}
  />;
};

NotOkRadioCircle.defaultProps = {};
export default NotOkRadioCircle;
